"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[902],{

/***/ 50902:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {



var _interopRequireWildcard = __webpack_require__(72269);

var _interopRequireDefault = __webpack_require__(50365);

var _Object$defineProperty = __webpack_require__(48449);

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.useScrollableStack = useScrollableStack;
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(14556));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(39561));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(59415));

var _react = _interopRequireWildcard(__webpack_require__(34885));

var _ = __webpack_require__(79329);

var _Box = _interopRequireDefault(__webpack_require__(40300));

var _responsiveHelpers = __webpack_require__(96775);

var _useHover = _interopRequireDefault(__webpack_require__(68854));

var _animatedScrollTo = _interopRequireDefault(__webpack_require__(34948));

var __jsx = _react["default"].createElement;

function easeOutExpo(x) {
  return x === 1 ? 1 : 1 - Math.pow(2, -10 * x);
}

function getNextPos(scrollableContainerRef, spacerRef, itemRefs) {
  var direction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var spacerWidth = spacerRef.current.getBoundingClientRect().width;
  var containerRect = scrollableContainerRef.current.getBoundingClientRect();
  var containerWidth = containerRect.width - spacerWidth * 2;
  var closestItem;
  var closestDiff = 999999;

  for (var i = 0; i < itemRefs.current.length; i++) {
    var item = itemRefs.current[i];
    var left = item.current.getBoundingClientRect().left - containerRect.left;
    var diff = Math.abs(left + containerWidth * direction - spacerWidth);

    if (diff < closestDiff) {
      closestItem = item.current;
      closestDiff = diff;
    }
  }

  var pos = scrollableContainerRef.current.scrollLeft + (closestItem.getBoundingClientRect().left - containerRect.left - spacerWidth); // snap to boundaries (1px problem)

  pos = Math.ceil(pos);

  if (Math.abs(pos) < 3) {
    pos = 0;
  }

  return pos;
}

function _scrollTo(container, pos) {
  container.style.willChange = "scroll-position";
  (0, _animatedScrollTo["default"])([pos, null], {
    elementToScroll: container,
    easing: easeOutExpo,
    minDuration: 500,
    maxDuration: 500
  }).then(function () {
    container.style.willChange = "auto";
  });
}
/**
 * Helper component placing components next to each other with gutter.
 *
 * Gutter can be responsive but items layout can not. So it's usable ONLY if on all resolutions items will be next to each other and won't wrap.
 */


function useScrollableStack(props) {
  var scrollableContainerRef = (0, _react.useRef)(null);
  var floatingElementRef = (0, _react.useRef)(null);

  var _useResponsiveHelpers = (0, _.useResponsiveHelpers)(),
      currentValue = _useResponsiveHelpers.currentValue; //
  // const scrollTo = x => {
  //   scrollableContainerRef.current.scroll({
  //     left: x,
  //     behavior: "smooth"
  //   });
  // };


  var _useState = (0, _react.useState)(true),
      isAtStart = _useState[0],
      setIsAtStart = _useState[1];

  var _useState2 = (0, _react.useState)(true),
      isAtEnd = _useState2[0],
      setIsAtEnd = _useState2[1];

  var itemRefs = (0, _react.useRef)(null);
  var spacerRef = (0, _react.useRef)(null);

  if (!itemRefs.current) {
    itemRefs.current = [];

    for (var i = 0; i < props.length; i++) {
      itemRefs.current.push(_react["default"].createRef());
    }
  }

  var setFloatingElementIndex = function setFloatingElementIndex(n) {
    if (!floatingElementRef.current) {
      return;
    }

    if (typeof props.length !== "number") {
      throw new Error("You're must pass 'length' parameter to useScrollableStack in order to make it work with floating element!!!");
    }

    var offsetLeft;
    var width;

    if (n === null) {
      offsetLeft = 0;
      width = 0;
    } else {
      offsetLeft = itemRefs.current[n].current.offsetLeft;
      width = itemRefs.current[n].current.clientWidth;
    }

    floatingElementRef.current.style.transform = "translateX(".concat(offsetLeft, "px)");
    floatingElementRef.current.style.width = "".concat(width, "px");
  };

  (0, _react.useEffect)(function () {
    setFloatingElementIndex(typeof props.initialFloatingElementIndex === "number" ? props.initialFloatingElementIndex : 0);
    setTimeout(function () {
      if (floatingElementRef.current) {
        floatingElementRef.current.style.transition = "all .15s ease-out";
      }
    }, 500);
  }, []);
  (0, _react.useEffect)(function () {
    var elem = scrollableContainerRef.current;

    var listener = function listener() {
      var isStart = elem.scrollLeft <= 0;
      var isEnd = elem.scrollWidth - elem.scrollLeft <= elem.clientWidth;
      setIsAtStart(isStart);
      setIsAtEnd(isEnd);
    };

    listener();
    elem.addEventListener("scroll", listener, {
      passive: true
    });
    return function () {
      elem.removeEventListener("scroll", listener);
    };
  }, []);
  var ret = {
    scrollTo: function scrollTo(pos) {
      _scrollTo(scrollableContainerRef.current, pos);
    },
    isAtStart: isAtStart,
    isAtEnd: isAtEnd
  }; // const currentContainerWidth = currentValue(padding) * 2;

  var previousButtonProps = {
    onClick: function onClick() {
      var newLeftPos = getNextPos(scrollableContainerRef, spacerRef, itemRefs, 1);

      _scrollTo(scrollableContainerRef.current, newLeftPos);
    }
  };
  var nextButtonProps = {
    onClick: function onClick() {
      var newLeftPos = getNextPos(scrollableContainerRef, spacerRef, itemRefs, -1);

      _scrollTo(scrollableContainerRef.current, newLeftPos);
    }
  };
  return (0, _objectSpread2["default"])({}, ret, {
    scrollableContainerRef: scrollableContainerRef,
    itemRefs: itemRefs.current,
    floatingElementRef: floatingElementRef,
    spacerRef: spacerRef,
    setFloatingElementIndex: setFloatingElementIndex,
    previousButtonProps: previousButtonProps,
    nextButtonProps: nextButtonProps
  });
}

function ScrollableStack(props) {
  var sx = props.sx,
      children = props.children,
      controller = props.controller,
      previousButton = props.previousButton,
      nextButton = props.nextButton,
      gap = props.gap,
      align = props.align,
      innerMargin = props.innerMargin,
      itemSize = props.itemSize,
      itemsVisible = props.itemsVisible,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["sx", "children", "controller", "previousButton", "nextButton", "gap", "align", "innerMargin", "itemSize", "itemsVisible"]);

  var _splitSx = (0, _.splitSx)(sx),
      _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
      css = _splitSx2[0],
      customSx = _splitSx2[1];

  var rootRef = (0, _react.useRef)(null);
  var isRootHovered = (0, _useHover["default"])(rootRef);
  gap = gap || customSx.$gap || 0;
  align = align || customSx.$align || "left";
  var padding = innerMargin || customSx.$innerMargin || 0;

  if (!controller) {
    controller = useScrollableStack((0, _objectSpread2["default"])({}, props, {
      length: props.children.length
    }));
  }

  var itemProps;
  itemSize = itemSize || customSx.$itemSize;
  itemsVisible = itemsVisible || customSx.$itemsVisible;

  if (itemSize) {
    itemProps = {
      width: itemSize
    };
  } else if (itemsVisible) {
    // TODO: unify responsive values arithmetics
    (0, _.responsiveValueForEach)(align, function (val) {
      if (val !== "left") {
        console.warn("Warning: ScrollableStack uses $itemsVisible + $align, this behaviour is not allowed. If you want to use $align, please use $itemSize property or go with natural item widths.");
      }
    });
    align = "left";
    var itemsVisibleMap = (0, _.responsiveValueToRangeMap)(itemsVisible);
    var paddingRs = (0, _.responsiveValueToResponsiveSize)(padding);
    var gapRs = (0, _.responsiveValueToResponsiveSize)(gap);
    var multiplier = {};
    itemsVisibleMap.forEach(function (itemsVisible, range) {
      multiplier[range.from] = (itemsVisible - 1) / itemsVisible;
    });
    var base = (0, _responsiveHelpers.rs)("100%"); // if (!props.itemsVisibleIncludeMargins) {

    base = base.subtract(paddingRs).subtract(paddingRs); // }

    var size = base.divide(itemsVisibleMap).subtract(gapRs.multiply(multiplier));
    itemProps = size.cssObject("width");
  }

  var floatingElement;

  if (customSx.$floatingElement) {
    floatingElement = (0, _.createElement)((0, _.getElementSpec)(customSx.$floatingElement, {
      __type: _Box["default"],
      position: "absolute",
      width: 0,
      zIndex: customSx.$floatingElementUnder ? -1 : 1,
      bottom: 0,
      left: 0
    }, {}), {
      _ref: controller.floatingElementRef
    });
  }
  /**
   * Inner container styles
   */


  var innerContainerStyles = {
    width: (0, _.responsiveValueMap)(align, function (x) {
      return x === "left" ? "100%" : undefined;
    }),
    ml: (0, _.responsiveValueMap)(align, function (x) {
      return x === "center" || x === "right" ? "auto" : "initial";
    }),
    mr: (0, _.responsiveValueMap)(align, function (x) {
      return x === "center" || x === "left" ? "auto" : "initial";
    })
  };

  var childrenArray = _react["default"].Children.toArray(children); // TODO: floating line!!! (rect) => ...

  /**
   * Buttons
   */


  if (previousButton) {
    if (typeof previousButton === "function") {
      previousButton = previousButton((0, _objectSpread2["default"])({}, controller, {
        isParentHovered: isRootHovered
      }));
    }

    if (_react["default"].isValidElement(previousButton)) {
      previousButton = {
        button: previousButton
      };
    }

    previousButton.offset = previousButton.offset || 0;
    previousButton.hideOnTouch = previousButton.hideOnTouch || true;

    if (typeof previousButton.button === "function") {
      previousButton.button = previousButton.button({
        buttonProps: controller.previousButtonProps
      });
    }
  }

  if (nextButton) {
    if (typeof nextButton === "function") {
      nextButton = nextButton((0, _objectSpread2["default"])({}, controller, {
        isParentHovered: isRootHovered
      }));
    }

    if (_react["default"].isValidElement(nextButton)) {
      nextButton = {
        button: nextButton
      };
    }

    nextButton.offset = nextButton.offset || 0;
    nextButton.hideOnTouch = nextButton.hideOnTouch || true;

    if (typeof nextButton.button === "function") {
      nextButton.button = nextButton.button({
        buttonProps: controller.nextButtonProps
      });
    }
  }

  return __jsx(_Box["default"], {
    sx: (0, _objectSpread2["default"])({
      position: "relative"
    }, css),
    _ref: rootRef
  }, __jsx(_Box["default"], {
    sx: [{
      position: "relative",
      display: "flex",
      height: "100%",
      minHeight: "inherit",
      overflowX: "auto",
      "::-webkit-scrollbar": {
        display: "none"
      },
      scrollbarWidth: "none"
    }],
    _ref: controller.scrollableContainerRef
  }, __jsx(_Box["default"], {
    sx: (0, _objectSpread2["default"])({
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap"
    }, innerContainerStyles)
  }, floatingElement, __jsx(_Box["default"], {
    sx: {
      position: "relative",
      flexGrow: 0,
      flexShrink: 0,
      flexBasis: padding,
      zIndex: 0
    },
    ref: controller.spacerRef
  }), childrenArray.map(function (child, index) {
    return __jsx(_Box["default"], {
      sx: (0, _objectSpread2["default"])({
        position: "relative",
        marginRight: index === childrenArray.length - 1 ? 0 : gap,
        flexGrow: 0,
        flexShrink: 0
      }, itemProps),
      key: child.key,
      _ref: controller.itemRefs[index]
    }, child);
  }), __jsx(_Box["default"], {
    sx: {
      position: "relative",
      flexGrow: 0,
      flexShrink: 0,
      flexBasis: padding
    }
  }))), previousButton && __jsx(_Box["default"], {
    sx: {
      position: "absolute",
      left: padding,
      top: 0,
      height: "100%",
      display: "flex",
      alignItems: "center"
    }
  }, __jsx(_Box["default"], {
    sx: (0, _objectSpread2["default"])({
      position: "relative",
      left: previousButton.offset
    }, previousButton.hideOnTouch ? {
      "@media not all and (pointer: fine)": {
        display: "none"
      }
    } : {})
  }, _react["default"].cloneElement(previousButton.button, controller.previousButtonProps))), nextButton && __jsx(_Box["default"], {
    sx: {
      position: "absolute",
      right: padding,
      top: 0,
      height: "100%",
      display: "flex",
      alignItems: "center"
    }
  }, __jsx(_Box["default"], {
    sx: (0, _objectSpread2["default"])({
      position: "relative",
      right: nextButton.offset
    }, nextButton.hideOnTouch ? {
      "@media not all and (pointer: fine)": {
        display: "none"
      }
    } : {})
  }, _react["default"].cloneElement(nextButton.button, controller.nextButtonProps))));
}

var _default = ScrollableStack;
exports["default"] = _default;

/***/ }),

/***/ 34948:
/***/ (function(__unused_webpack_module, exports) {


var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
// --------- HELPERS
function getElementOffset(el) {
    let top = 0;
    let left = 0;
    let element = el;
    // Loop through the DOM tree
    // and add it's parent's offset to get page offset
    do {
        top += element.offsetTop || 0;
        left += element.offsetLeft || 0;
        element = element.offsetParent;
    } while (element);
    return {
        top,
        left,
    };
}
// --------- SCROLL INTERFACES
// ScrollDomElement and ScrollWindow have identical interfaces
class ScrollDomElement {
    constructor(element) {
        this.element = element;
    }
    getHorizontalScroll() {
        return this.element.scrollLeft;
    }
    getVerticalScroll() {
        return this.element.scrollTop;
    }
    getMaxHorizontalScroll() {
        return this.element.scrollWidth - this.element.clientWidth;
    }
    getMaxVerticalScroll() {
        return this.element.scrollHeight - this.element.clientHeight;
    }
    getHorizontalElementScrollOffset(elementToScrollTo, elementToScroll) {
        return (getElementOffset(elementToScrollTo).left -
            getElementOffset(elementToScroll).left);
    }
    getVerticalElementScrollOffset(elementToScrollTo, elementToScroll) {
        return (getElementOffset(elementToScrollTo).top -
            getElementOffset(elementToScroll).top);
    }
    scrollTo(x, y) {
        this.element.scrollLeft = x;
        this.element.scrollTop = y;
    }
}
class ScrollWindow {
    constructor() {
        this.element = window;
    }
    getHorizontalScroll() {
        return window.scrollX || document.documentElement.scrollLeft;
    }
    getVerticalScroll() {
        return window.scrollY || document.documentElement.scrollTop;
    }
    getMaxHorizontalScroll() {
        return (Math.max(document.body.scrollWidth, document.documentElement.scrollWidth, document.body.offsetWidth, document.documentElement.offsetWidth, document.body.clientWidth, document.documentElement.clientWidth) - window.innerWidth);
    }
    getMaxVerticalScroll() {
        return (Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight) - window.innerHeight);
    }
    getHorizontalElementScrollOffset(elementToScrollTo) {
        const scrollLeft = window.scrollX || document.documentElement.scrollLeft;
        return scrollLeft + elementToScrollTo.getBoundingClientRect().left;
    }
    getVerticalElementScrollOffset(elementToScrollTo) {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        return scrollTop + elementToScrollTo.getBoundingClientRect().top;
    }
    scrollTo(x, y) {
        window.scrollTo(x, y);
    }
}
const activeAnimations = {
    elements: [],
    cancelMethods: [],
    add: (element, cancelAnimation) => {
        activeAnimations.elements.push(element);
        activeAnimations.cancelMethods.push(cancelAnimation);
    },
    remove: (element, shouldStop) => {
        const index = activeAnimations.elements.indexOf(element);
        if (index > -1) {
            // Stop animation
            if (shouldStop) {
                activeAnimations.cancelMethods[index]();
            }
            // Remove it
            activeAnimations.elements.splice(index, 1);
            activeAnimations.cancelMethods.splice(index, 1);
        }
    },
};
// --------- CHECK IF CODE IS RUNNING IN A BROWSER
const WINDOW_EXISTS = typeof window !== 'undefined';
// --------- ANIMATE SCROLL TO
const defaultOptions = {
    cancelOnUserAction: true,
    easing: (t) => --t * t * t + 1, // easeOutCubic
    elementToScroll: WINDOW_EXISTS ? window : null, // Check for server side rendering
    horizontalOffset: 0,
    maxDuration: 3000,
    minDuration: 250,
    speed: 500,
    verticalOffset: 0,
};
function animateScrollTo(numberOrCoordsOrElement_1) {
    return __awaiter(this, arguments, void 0, function* (numberOrCoordsOrElement, userOptions = {}) {
        // Check for server rendering
        if (!WINDOW_EXISTS) {
            // @ts-ignore
            // If it still gets called on server, return Promise for API consistency
            return new Promise((resolve) => {
                resolve(false); // Returning false on server
            });
        }
        else if (!window.Promise) {
            throw "Browser doesn't support Promises, and animated-scroll-to depends on it, please provide a polyfill.";
        }
        let x;
        let y;
        let scrollToElement;
        let options = Object.assign(Object.assign({}, defaultOptions), userOptions);
        const isWindow = options.elementToScroll === window;
        const isElement = !!options.elementToScroll.nodeName;
        if (!isWindow && !isElement) {
            throw 'Element to scroll needs to be either window or DOM element.';
        }
        // Check for a few properties that can break the animation
        // "scroll-behavior: smooth"
        // "scroll-snap-type: [x/y] mandatory"
        // https://github.com/Stanko/animated-scroll-to/issues/55
        // https://github.com/Stanko/animated-scroll-to/issues/71
        const WARN_ABOUT = [
            { property: 'scroll-behavior', value: 'smooth' },
            { property: 'scroll-snap-type', value: 'mandatory' },
        ];
        const scrollBehaviorElement = isWindow
            ? document.documentElement
            : options.elementToScroll;
        const computedStyles = getComputedStyle(scrollBehaviorElement);
        WARN_ABOUT.forEach(({ property, value }) => {
            const cssValue = computedStyles.getPropertyValue(property);
            if (cssValue.includes(value)) {
                console.warn(`${scrollBehaviorElement.tagName} has "${property}: ${cssValue}" which can break animated-scroll-to's animations`);
            }
        });
        // Select the correct scrolling interface
        const elementToScroll = isWindow
            ? new ScrollWindow()
            : new ScrollDomElement(options.elementToScroll);
        if (numberOrCoordsOrElement instanceof Element) {
            scrollToElement = numberOrCoordsOrElement;
            // If "elementToScroll" is not a parent of "scrollToElement"
            if (isElement &&
                (!options.elementToScroll.contains(scrollToElement) ||
                    options.elementToScroll.isSameNode(scrollToElement))) {
                throw 'options.elementToScroll has to be a parent of scrollToElement';
            }
            x = elementToScroll.getHorizontalElementScrollOffset(scrollToElement, options.elementToScroll);
            y = elementToScroll.getVerticalElementScrollOffset(scrollToElement, options.elementToScroll);
        }
        else if (typeof numberOrCoordsOrElement === 'number') {
            x = elementToScroll.getHorizontalScroll();
            y = numberOrCoordsOrElement;
        }
        else if (Array.isArray(numberOrCoordsOrElement) &&
            numberOrCoordsOrElement.length === 2) {
            x =
                numberOrCoordsOrElement[0] === null
                    ? elementToScroll.getHorizontalScroll()
                    : numberOrCoordsOrElement[0];
            y =
                numberOrCoordsOrElement[1] === null
                    ? elementToScroll.getVerticalScroll()
                    : numberOrCoordsOrElement[1];
        }
        else {
            // ERROR
            throw ('Wrong function signature. Check documentation.\n' +
                'Available method signatures are:\n' +
                '  animateScrollTo(y:number, options)\n' +
                '  animateScrollTo([x:number | null, y:number | null], options)\n' +
                '  animateScrollTo(scrollToElement:Element, options)');
        }
        // Add offsets
        x += options.horizontalOffset;
        y += options.verticalOffset;
        // Horizontal scroll distance
        const maxHorizontalScroll = elementToScroll.getMaxHorizontalScroll();
        const initialHorizontalScroll = elementToScroll.getHorizontalScroll();
        // If user specified scroll position is greater than maximum available scroll
        if (x > maxHorizontalScroll) {
            x = maxHorizontalScroll;
        }
        // Calculate distance to scroll
        const horizontalDistanceToScroll = x - initialHorizontalScroll;
        // Vertical scroll distance distance
        const maxVerticalScroll = elementToScroll.getMaxVerticalScroll();
        const initialVerticalScroll = elementToScroll.getVerticalScroll();
        // If user specified scroll position is greater than maximum available scroll
        if (y > maxVerticalScroll) {
            y = maxVerticalScroll;
        }
        // Calculate distance to scroll
        const verticalDistanceToScroll = y - initialVerticalScroll;
        // Calculate duration of the scroll
        const horizontalDuration = Math.abs(Math.round((horizontalDistanceToScroll / 1000) * options.speed));
        const verticalDuration = Math.abs(Math.round((verticalDistanceToScroll / 1000) * options.speed));
        let duration = horizontalDuration > verticalDuration
            ? horizontalDuration
            : verticalDuration;
        // Set minimum and maximum duration
        if (duration < options.minDuration) {
            duration = options.minDuration;
        }
        else if (duration > options.maxDuration) {
            duration = options.maxDuration;
        }
        // @ts-ignore
        return new Promise((resolve, reject) => {
            // Scroll is already in place, nothing to do
            if (horizontalDistanceToScroll === 0 && verticalDistanceToScroll === 0) {
                // Resolve promise with a boolean hasScrolledToPosition set to true
                resolve(true);
            }
            // Cancel existing animation if it is already running on the same element
            activeAnimations.remove(elementToScroll.element, true);
            // To cancel animation we have to store request animation frame ID
            let requestID;
            // Cancel animation handler
            const cancelAnimation = () => {
                removeListeners();
                cancelAnimationFrame(requestID);
                // Resolve promise with a boolean hasScrolledToPosition set to false
                resolve(false);
            };
            // Registering animation so it can be canceled if function
            // gets called again on the same element
            activeAnimations.add(elementToScroll.element, cancelAnimation);
            // Prevent user actions handler
            const preventDefaultHandler = (e) => e.preventDefault();
            const handler = options.cancelOnUserAction
                ? cancelAnimation
                : preventDefaultHandler;
            // If animation is not cancelable by the user, we can't use passive events
            const eventOptions = options.cancelOnUserAction
                ? { passive: true }
                : { passive: false };
            const events = ['wheel', 'touchstart', 'keydown', 'mousedown'];
            // Function to remove listeners after animation is finished
            const removeListeners = () => {
                events.forEach((eventName) => {
                    elementToScroll.element.removeEventListener(eventName, handler, eventOptions);
                });
            };
            // Add listeners
            events.forEach((eventName) => {
                elementToScroll.element.addEventListener(eventName, handler, eventOptions);
            });
            // Animation
            const startingTime = Date.now();
            const step = () => {
                var timeDiff = Date.now() - startingTime;
                var t = timeDiff / duration;
                const horizontalScrollPosition = Math.round(initialHorizontalScroll +
                    horizontalDistanceToScroll * options.easing(t));
                const verticalScrollPosition = Math.round(initialVerticalScroll + verticalDistanceToScroll * options.easing(t));
                if (timeDiff < duration &&
                    (horizontalScrollPosition !== x || verticalScrollPosition !== y)) {
                    // If scroll didn't reach desired position or time is not elapsed
                    // Scroll to a new position
                    elementToScroll.scrollTo(horizontalScrollPosition, verticalScrollPosition);
                    // And request a new step
                    requestID = requestAnimationFrame(step);
                }
                else {
                    // If the time elapsed or we reached the desired offset
                    // Set scroll to the desired offset (when rounding made it to be off a pixel or two)
                    // Clear animation frame to be sure
                    elementToScroll.scrollTo(x, y);
                    cancelAnimationFrame(requestID);
                    // Remove listeners
                    removeListeners();
                    // Remove animation from the active animations coordinator
                    activeAnimations.remove(elementToScroll.element, false);
                    // Resolve promise with a boolean hasScrolledToPosition set to true
                    resolve(true);
                }
            };
            // Start animating scroll
            requestID = requestAnimationFrame(step);
        });
    });
}
exports["default"] = animateScrollTo;


/***/ })

}]);